import React from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import FindLoadButton from 'tennders-transactions/views/common/FindLoadButton'
import FindTruckButton from 'tennders-transactions/views/common/FindTruckButton'
import { STATUS_WAITING_FOR_OFFER } from 'tennders-stracture/libs/constants'
import useTranslation from 'next-translate/useTranslation'

const getMessage = (transaction, t) => (
  transaction.matchedLoad
    ? (
      <>
        {t('offer:load_no_offer_msg')}
        <br />

        {transaction?.isMatchable && t('offer:look_for_truck_msg')}
      </>
    )
    : (
      <>
        {t('offer:truck_no_offer_msg')}
        <br />
        {transaction?.isMatchable && t('offer:look_for_load_msg')}
      </>
    )
)

const getFind = (transaction) => (transaction.matchedLoad ? <FindTruckButton withIcon transaction={transaction} />
  : <FindLoadButton withIcon transaction={transaction} />)

const WaitingForOffer = () => {
  const { transaction } = useTransaction()
  const { t } = useTranslation()

  return transaction?.isMine && transaction.status?.label === STATUS_WAITING_FOR_OFFER
    ? (
      <div className="bg-color-white p-24 text-center">
        <p>{getMessage(transaction, t)}</p>
        {transaction?.isMatchable && (
          getFind(transaction)
        )}
      </div>
    ) : null
}

export default WaitingForOffer
